import { useState } from "react";
import SiteContentEditor from "./SiteContentEditor";
import TestimonialsManager from "./TestimonialsManager";
import TransformationsManager from "./TransformationsManager";
import { ArrowSquareOut, ArrowsClockwise } from "@phosphor-icons/react";

const TABS = [
  { key: "content", label: "Page Content" },
  { key: "testimonials", label: "Testimonials" },
  { key: "transformations", label: "Transformations" },
];

export default function WebsiteEditorPanel() {
  const [tab, setTab] = useState("content");
  const [previewKey, setPreviewKey] = useState(0);
  const [showPreview, setShowPreview] = useState(true);

  const refreshPreview = () => setPreviewKey((k) => k + 1);

  return (
    <div data-testid="website-editor-panel">
      <div className="flex items-center justify-between mb-6 gap-4 flex-wrap">
        <div>
          <h1 className="font-heading text-3xl text-white tracking-tight">Website Editor</h1>
          <p className="text-sm text-[#71717A] mt-1">Update live homepage text, testimonials and transformation photos &mdash; no code required.</p>
        </div>
        <button
          data-testid="toggle-preview-button"
          onClick={() => setShowPreview((s) => !s)}
          className="text-sm border border-[#27272A] text-[#A1A1AA] hover:text-white hover:border-[#D4AF37]/60 rounded-full px-4 py-2 transition-colors"
        >
          {showPreview ? "Hide Preview" : "Show Preview"}
        </button>
      </div>

      <div className="flex gap-2 mb-6 border-b border-[#27272A]">
        {TABS.map((t) => (
          <button
            key={t.key}
            data-testid={`website-editor-tab-${t.key}`}
            onClick={() => setTab(t.key)}
            className={`px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
              tab === t.key ? "border-[#D4AF37] text-white" : "border-transparent text-[#71717A] hover:text-white"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className={`grid gap-6 ${showPreview ? "lg:grid-cols-[1.1fr_0.9fr]" : ""}`}>
        <div>
          {tab === "content" && <SiteContentEditor onSaved={refreshPreview} />}
          {tab === "testimonials" && <TestimonialsManager />}
          {tab === "transformations" && <TransformationsManager />}
        </div>

        {showPreview && (
          <div data-testid="website-live-preview" className="hidden lg:block sticky top-6 self-start">
            <div className="bg-[#141414] border border-[#27272A] rounded-2xl overflow-hidden">
              <div className="flex items-center justify-between px-4 py-3 border-b border-[#27272A]">
                <p className="text-xs uppercase tracking-wide text-[#71717A]">Live Preview</p>
                <div className="flex items-center gap-2">
                  <button data-testid="preview-refresh-button" onClick={refreshPreview} className="text-[#71717A] hover:text-white transition-colors" title="Refresh preview">
                    <ArrowsClockwise size={16} />
                  </button>
                  <a href="/" target="_blank" rel="noreferrer" data-testid="preview-open-tab-button" className="text-[#71717A] hover:text-white transition-colors" title="Open in new tab">
                    <ArrowSquareOut size={16} />
                  </a>
                </div>
              </div>
              <iframe key={previewKey} data-testid="website-preview-iframe" title="Homepage Preview" src="/" className="w-full" style={{ height: "70vh" }} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
